/*酒店库 */
import { $http, buildHeaders } from "./index";

//获取列表
export const hotel_page = (params) => {
  return $http.get("/admin/Hotel/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const hotel_detail = (id) => {
  return $http.get("/admin/Hotel/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const hotel_add = (data) => {
  return $http.post("/admin/Hotel/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const hotel_edit = (data) => {
  return $http.post("/admin/Hotel/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改状态
export const hotel_updateStatus = (data) => {
  return $http.post("/admin/Hotel/updateStatus", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const hotel_delete = (id) => {
  return $http.post(
    "/admin/Hotel/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

/**联系人 */

//获取列表
export const hotel_contact_page = (params) => {
  return $http.get("/admin/HotelContact/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const hotel_contact_detail = (id) => {
  return $http.get("/admin/HotelContact/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const hotel_contact_add = (data) => {
  return $http.post("/admin/HotelContact/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const hotel_contact_edit = (data) => {
  return $http.post("/admin/HotelContact/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const hotel_contact_delete = (id) => {
  return $http.post(
    "/admin/HotelContact/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};


/**房型 */

//获取列表
export const hotel_roomtype_page = (params) => {
  return $http.get("/admin/HotelRoomType/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const hotel_roomtype_detail = (id) => {
  return $http.get("/admin/HotelRoomType/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const hotel_roomtype_add = (data) => {
  return $http.post("/admin/HotelRoomType/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const hotel_roomtype_edit = (data) => {
  return $http.post("/admin/HotelRoomType/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const hotel_roomtype_delete = (id) => {
  return $http.post(
    "/admin/HotelRoomType/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

/**宴会厅 */

//获取列表
export const hotel_hall_page = (params) => {
  return $http.get("/admin/HotelHall/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const hotel_hall_detail = (id) => {
  return $http.get("/admin/HotelHall/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const hotel_hall_add = (data) => {
  return $http.post("/admin/HotelHall/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const hotel_hall_edit = (data) => {
  return $http.post("/admin/HotelHall/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const hotel_hall_delete = (id) => {
  return $http.post(
    "/admin/HotelHall/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

/**附件 */

//获取列表
export const hotel_attachment_page = (params) => {
  return $http.get("/admin/HotelAttachment/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const hotel_attachment_add = (data) => {
  return $http.post("/admin/HotelAttachment/add", data, {
    headers: buildHeaders(2, "正在提交数据，请稍后……"),
  });
};

//删除
export const hotel_attachment_delete = (id) => {
  return $http.post(
    "/admin/HotelAttachment/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};